import * as React from "react";
import type { SVGProps } from "react";
const SvgArrowRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M21.92 12.38a1 1 0 0 0-.22-1.09l-8.99-9A.996.996 0 1 0 11.3 3.7l7.29 7.29H3c-.55 0-1 .45-1 1s.45 1 1 1h15.59l-7.29 7.29a.996.996 0 0 0 .71 1.7c.26 0 .51-.1.71-.29l9-9c.09-.09.17-.2.22-.33z"
    />
  </svg>
);
export default SvgArrowRight;
